import { render, staticRenderFns } from "./modal-files-management.vue?vue&type=template&id=0d481471&scoped=true&"
import script from "./modal-files-management.vue?vue&type=script&lang=js&"
export * from "./modal-files-management.vue?vue&type=script&lang=js&"
import style0 from "./modal-files-management.vue?vue&type=style&index=0&id=0d481471&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d481471",
  null
  
)

export default component.exports